import StagePanel from "../../../lib/stage_panel";

// The one block class every SuggestionPanel stage panel wears, so --active / --inactive land
// on the same class for all six (each panel adds its own --<phase> modifier alongside it).
export const SUGGESTION_PANEL_BASE_HTML_CLASS = "suggestion_panel__panel";

// Shared base for the SuggestionPanel stage panels (Contribution, Identity, Verify,
// Password, Forgot, Sent). The host's ONE state machine + the renderPanelVisibility
// preamble come from the shared lib/stage_panel base; this class adds the auth-status /
// busy painting the auth panels share — the exact counterpart of AccountPanelComponent.
//
// `host` is the SuggestionPanel: panels delegate intents to it (host.submitCode(),
// host.canResend(), …) and never reach through it to its collaborators — the AuthClient is
// the host's, and that one coupling rule keeps the panels ignorant of it.
export default class SuggestionPanelComponent extends StagePanel {

  // Render the shared authStatus into this panel's own status element (host-owned status
  // truth, each surface its own placement/BEM).
  renderAuthStatus(statusEl) {
    if (!statusEl) return;
    const status = this.readStateMachineValue("authStatus");
    statusEl.textContent = status ? status.text : "";
    ["info", "error", "busy"].forEach((t) => statusEl.classList.remove(`suggestion_panel__status--${t}`));
    if (status && status.tone) statusEl.classList.add(`suggestion_panel__status--${status.tone}`);
  }

  // Disable the given inputs while an auth request is in flight.
  applyBusy(inputs = []) {
    const busy = !!this.readStateMachineValue("authBusy");
    inputs.forEach((input) => { if (input) input.disabled = busy; });
  }
}
